import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface PantheonConfig {
  apiUrl: string;
  wsUrl: string;
  authToken: string;
}

interface PantheonContextValue {
  config: PantheonConfig;
  apiUrl: string;
  wsUrl: string;
  authToken: string;
}

const PantheonContext = createContext<PantheonContextValue | null>(null);

export interface PantheonProviderProps {
  config: PantheonConfig;
  children: ReactNode;
}

export function PantheonProvider({ config, children }: PantheonProviderProps) {
  const value = useMemo<PantheonContextValue>(
    () => ({
      config,
      apiUrl: config.apiUrl.replace(/\/$/, ''),
      wsUrl: config.wsUrl,
      authToken: config.authToken,
    }),
    [config],
  );

  return (
    <PantheonContext.Provider value={value}>
      {children}
    </PantheonContext.Provider>
  );
}

export function usePantheon(): PantheonContextValue {
  const context = useContext(PantheonContext);
  if (!context) {
    throw new Error('usePantheon must be used within a <PantheonProvider>');
  }
  return context;
}
